/**
 * ReportListPage - styles
 */

import styled from 'styled-components';
import { mediaQueries } from 'theme';
import { px2rem } from 'theme/utils';

export const Content = styled.div`
	max-width: ${px2rem(1200)};
	margin: 0.5rem auto 0;

	@media (max-width: 1024px) {
		padding-left: 1rem;
		padding-right: 1rem;
	}
`;

export const ResultsContainer = styled.div`
	${mediaQueries.phone} {
		padding-top: 1rem;
	}
`;
